import moment from 'moment';
import _ from 'lodash';
import apiClient from '@shared/lib/general/apiClient';
import createCycles from './createCycles';

const rangedData = async (systemFilter, serials,
  corpId, customerData, sensors, tZones) => {
  try {
    const cycleRequest = [];
    const dailyRequest = [];
    let startDate;
    let endDate;

    if (systemFilter.dateRange.start && systemFilter.dateRange.end) {
      endDate = moment(systemFilter.dateRange.end).endOf('day').toISOString();
      startDate = moment(systemFilter.dateRange.start).toISOString();
    } else if (systemFilter.dateFilter === 'past3') {
      endDate = moment().toISOString();
      startDate = moment().subtract(3, 'days').toISOString();
    } else if (systemFilter.dateFilter === 'past7') {
      endDate = moment().toISOString();
      startDate = moment().subtract(7, 'days').toISOString();
    } else if (systemFilter.dateFilter === 'past30') {
      endDate = moment().toISOString();
      startDate = moment().subtract(30, 'days').toISOString();
    } else if (systemFilter.dateFilter === 'yesterday') {
      endDate = moment().toISOString();
      startDate = moment().subtract(1, 'days').toISOString();
    } else if (systemFilter.dateFilter === 'today') {
      endDate = moment().toISOString();
      startDate = moment().startOf('day').toISOString();
    }

    const findRuntimeIndex = serials.findIndex(s => s === systemFilter.singleTZone);

    serials.forEach((serial) => {
      cycleRequest.push(
        apiClient({
          method: 'GET',
          url: `/devices/acCycle/hub/${serial}/start/${startDate}/end/${endDate}`,
        }),
      );
      dailyRequest.push(
        apiClient({
          method: 'GET',
          url: `/devices/acCycle/daily/hub/${serial}/start/${startDate.split('T')[0]}/end/${endDate.split('T')[0]}`,
        }),
      );
    });

    const result = await Promise.all(cycleRequest);
    const res = await Promise.all(dailyRequest);

    const cycles = createCycles({
      result,
      res,
      customer: customerData,
      sensors,
      tZones,
    });

    cycles.sort((a, b) => {
      if (a.startTime > b.startTime) {
        return -1;
      }

      if (a.startTime < b.startTime) {
        return 1;
      }
      return 0;
    });

    const newCycles = _.cloneDeep(cycles);

    let newDailyTrends = [];
    if (findRuntimeIndex >= 0 && res[findRuntimeIndex] && res[findRuntimeIndex].data) {
      newDailyTrends = res[findRuntimeIndex].data;
    }

    return {
      newCycles,
      newDailyTrends,
    };
  } catch (err) {
    throw err;
  }
};

export default rangedData;
